import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0A0E27] border-t border-[#1E293B] py-12" data-id="element-107" data-mp="3gh3ng3oilm9v">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108" data-mp="32pp6e2e63v5g">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-6" data-id="element-109" data-mp="36ooajks2rnvu">
          <div className="text-[#94A3B8] text-sm" data-id="element-110" data-mp="3uesbfkdvp9j5">
            © {currentYear} CRM Kraft. Alle Rechte vorbehalten.
          </div>
          <div className="flex gap-6 text-sm text-[#94A3B8]" data-id="element-111" data-mp="387drhtbj3d5">
            <Link to="/impressum" className="hover:text-white transition-colors" data-id="element-112" data-mp="3levhp4cmtkh8">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors" data-id="element-113" data-mp="3qf9qiom24ygb">
              Datenschutz
            </Link>
            <a href="https://crm-kraft.de/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors flex items-center gap-1" data-id="element-114" data-mp="2ezutjktum6l7">
              CRM Kraft
              <ExternalLink className="w-3 h-3" data-id="element-115" data-mp="3v7gha5qpmkbx" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}